import { memo, useCallback, useContext } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { MediaPlaybackControlsContext } from '../../context/MediaPlaybackControlsContext';
import { Button } from 'foundations-components/transitional/components/Button';
import I18n from 'I18n';
import { useControlsStatus } from '../../hooks/_internal/useShouldDisableControls';
import { SeekForward15Icon } from 'foundations-assets/icons/components/SeekForward15Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const ForwardBtn = /*#__PURE__*/memo(props => {
  const {
    forward
  } = useContext(MediaPlaybackControlsContext);
  const {
    onForwardCallback
  } = props;
  const handleForwardClick = useCallback(() => {
    forward(15);
    if (onForwardCallback) {
      onForwardCallback();
    }
  }, [forward, onForwardCallback]);
  const {
    isDisabled,
    isError,
    isLoaded
  } = useControlsStatus();
  return /*#__PURE__*/_jsx(Flex, {
    flexDirection: "column",
    alignItems: "center",
    children: /*#__PURE__*/_jsx(Button, {
      "data-test-id": "mediaPlayerControls-forwardButton",
      onClick: handleForwardClick,
      use: "unstyled",
      disabled: isDisabled,
      "aria-label": I18n.text('recordingReviewComponents.media.mediaPlayer.ariaLabels.forward15'),
      children: /*#__PURE__*/_jsx(SeekForward15Icon, {
        color: isLoaded && !isError ? 'fill-accent-neutral-default' : 'fill-primary-disabled',
        size: "700"
      })
    })
  });
});
export default ForwardBtn;